import React, {useCallback, useMemo} from 'react';
import {Select} from "antd";
import {useQuery} from "react-query";
import axios, {AxiosResponse} from "axios";
import {ContentWarning} from "./types";
import {useTranslation} from "react-i18next";

export type TriggerWarningSelectorProps = {
    value?: string[],
    onChange?: (value: string[] | undefined) => void;
    loading?: boolean;
}

export const TriggerWarningSelector: React.FC<TriggerWarningSelectorProps> = (props) => {
    const { t } = useTranslation();
    const {data: allWarnings} = useQuery({
        queryKey: `api-launcher-all-content-warnings`,
        queryFn: () => axios.get<object, AxiosResponse<ContentWarning[]>>(`/api/launcher/content-warnings`).then(r => r.data)
    });
    const {value, onChange, loading} = props;
    const normalizedWarnings = useMemo<ContentWarning[]>(() => allWarnings || [], [allWarnings]);
    const internalOnChange = useCallback((changed: string[] | null) => {
        if (!onChange) {
            return;
        }
        const externalValue = normalizedWarnings.filter((warning) => changed?.includes(warning.id));
        onChange(externalValue?.map(warning => warning.id));
    }, [normalizedWarnings]);


    return (
        <Select value={value} onChange={internalOnChange} loading={loading} mode={"tags"}>
            {normalizedWarnings.map((warning) => <Select.Option key={warning.id} value={warning.id}>{t(warning.key)}</Select.Option>)}
        </Select>
    );
}